<template>
  <div class="l-task" @click="close($event)">
    <div class="l-task-main">
      <Week :week="week" @toggle="onChangeWeek" />
      <List :levels="levels" />
    </div>
    <span class="l-close">
      <i class="icon-lily icon-lily-guanbi1"></i>
    </span>
  </div>
</template>

<script>
import List from './components/list'
import Week from './components/week'
export default {
  name: 'l-task',
  components: { Week, List },
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {
      levels: [],
      week: {},
      index: 0,
    }
  },
  watch: {
    index() {
      this._composeWeek()
      this._compose()
    },
  },
  mounted() {
    if (this.data) {
      this._composeWeek()
      this._compose()
    }
  },
  methods: {
    onChangeWeek(index) {
      this.index += index
    },
    _composeWeek() {
      this.week = {
        id: this.data[this.index].id,
        startTime: this._formatTime(this.data[this.index].startTime),
        endTime: this._formatTime(this.data[this.index].endTime),
        weekId: this.data[this.index].weekId,
        isCurrent: false,
        isLast: this.index >= this.data.length - 1,
        isFirst: this.index === 0,
      }
    },
    _formatTime(timestamp) {
      const dt = new Date(timestamp)

      function _padStart(num) {
        return num > 9 ? num : `0${num}`
      }

      const y = dt.getFullYear()
      const m = dt.getMonth() + 1
      const d = dt.getDate()

      return `${y}-${_padStart(m)}-${_padStart(d)}`
    },
    _compose() {
      let stage = null
      this.levels = []
      this.data[this.index].lessons.forEach((item) => {
        if (!stage) {
          stage = {
            id: item.parentId,
            name: item.parentName,
            type: item.parentType,
            datas: [],
          }
        }

        if (!this._have(item, stage.datas, 'id')) {
          stage.datas.push(item)
        }
        if (!this._have(item, this.levels, 'id')) {
          this.levels.push(stage)
          stage = null
        }
      })
    },
    _have(item, list, key) {
      let b = false
      for (let i = 0; i < list.length; i++) {
        if (item[key] === list[i][key]) {
          b = true
          break
        }
      }

      return b
    },
    close(e) {
      if (e.target.className.indexOf('l-task') >= 0) {
        this.$emit('close')
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import 'index.styl'
</style>
